import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Navigation from '@segment/templates/Navigation'

import Footer from '@segment/templates/Footer'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import BusinessLeaders from './components/BusinessLeaders'
import TeradataTestimonial from './components/TeradataTestimonial'
import HubspotTestimonial from './components/HubspotTestimonial'
import InaccurateData from './components/InaccurateData'
import Chatbots from './components/Chatbots'
import RequestDemo from './components/RequestDemo'
import AiAdoption from './components/AiAdoption'
import IntuitTestimonial from './components/IntuitTestimonial'

import ogImagePng from './assets/OgStateOfPersonalizationReport2024.jpg'

const StateOfPersonalizationReport2024 = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="The State of Personalization Report 2024 | Twilio Segment"
        pageDescription="The State of Personalization Report 2024, Twilio Segment's annual look at the latest trends in personalization, consumer loyalty, AI, and more."
        pageOG={ogImagePng}
        themeColor={theme.palette.twilio.gray[10]}
      >
        <Navigation />
        <Hero appearance="twilioDark" />
        <Main>
          <BusinessLeaders />
          <TeradataTestimonial />
          <AiAdoption appearance="twilioDark" />
          <IntuitTestimonial />
          <InaccurateData />
          <HubspotTestimonial />
          <Chatbots />
          <RequestDemo />
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

export default StateOfPersonalizationReport2024
